import TYPES from '../actions/types';

const INITIAL_STATE = {
    list: [],
    paging: {},
    horas: {}
};

export const studentCourseDoneReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TYPES.SET_STUDENT_COURSE_DONE:
            const { count, current, page, pageCount, sort, direction } = action.payload.paging;
            return {
                ...state, 
                list: action.payload.list, 
                paging: { count, current, page, pageCount, sort, direction },
                horas: action.payload.horas
            };

        default:
            return state;
    }
};